import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, Gift, ArrowRight, Star, Sparkles } from 'lucide-react';
import { isPromoActive, PROMO } from '../data/promo-config';

const NEW_BOOK_COVER =
  'https://customer-assets.emergentagent.com/job_5d4ad1e7-aed7-4c2c-bd02-652824eb659e/artifacts/m0moy2po_FUCK_THATT_What_Do_I_Want_NOW_KDP_Ebook_Cover_1600x2560.png';
const NEW_BOOK_AMAZON = 'https://www.amazon.com/dp/B0GZN2ZZ5V';

export default function BookPromoPage() {
  const promo = isPromoActive();
  return (
    <section className="bpp" data-testid="book-promo-page">
      {/* Subtle floating embers like the rest of the site */}
      <div className="bpp-particles" aria-hidden="true">
        {Array.from({ length: 8 }).map((_, i) => (
          <span key={i} className={`bpp-particle bpp-particle--${i + 1}`} />
        ))}
      </div>

      <div className="bpp-inner">
        <div className="bpp-cover-wrap">
          <img
            src={NEW_BOOK_COVER}
            alt="F.U.C.K. T.H.A.T.T. — What Do I Want NOW! by Cabrini Schnyder"
            className="bpp-cover"
            data-testid="bpp-cover"
          />
          <div className="bpp-cover-glow" aria-hidden="true" />
          <div className={`bpp-new-badge ${promo ? 'bpp-new-badge--free' : ''}`}>
            <Sparkles size={13} strokeWidth={2.2} />
            <span>{promo ? `FREE · ${PROMO.shortLabel}` : 'Available Now · 2026'}</span>
          </div>
        </div>

        <div className="bpp-text">
          <p className="bpp-eyebrow">{promo ? `🔥 FREE on Amazon · ${PROMO.longLabel}` : 'A Book by Cabrini Schnyder'}</p>
          <h1 className="bpp-title" data-testid="bpp-title">
            F.U.C.K. T.H.A.T.T.
            <span>What Do I Want NOW!</span>
          </h1>

          <div className="bpp-stars" aria-label="5 out of 5 stars">
            {[...Array(5)].map((_, i) => (
              <Star key={i} size={14} fill="#D4AF37" stroke="#D4AF37" />
            ))}
            <span className="bpp-stars-text">For women 50+ asking "Now what?"</span>
          </div>

          <p className="bpp-pitch">
            Ditch the bullsh*t.<br />
            Get crystal clear.<br />
            Create a life that feels like freedom.
          </p>

          <div className="bpp-ctas">
            <a
              href={NEW_BOOK_AMAZON}
              target="_blank"
              rel="noopener noreferrer"
              className="bpp-btn bpp-btn--primary"
              data-testid="bpp-amazon"
            >
              <ShoppingCart size={18} />
              {promo ? 'Download FREE on Amazon' : 'Get the Book on Amazon'}
            </a>
            <Link
              to="/gift"
              className="bpp-btn bpp-btn--secondary"
              data-testid="bpp-free-chapter"
            >
              <Gift size={18} />
              Read a Free Chapter
            </Link>
          </div>

          {/* Soft "explore the Village" footer CTA — this is the bridge to the site */}
          <Link to="/" className="bpp-village-link" data-testid="bpp-village">
            <span className="bpp-village-label">Curious about Cabrini's world?</span>
            <span className="bpp-village-cta">
              Step into The Alchemy Village
              <ArrowRight size={14} strokeWidth={2.2} />
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}
